import { render, staticRenderFns } from "./Quick.vue?vue&type=template&id=2c98e943&scoped=true&"
import script from "./Quick.vue?vue&type=script&lang=js&"
export * from "./Quick.vue?vue&type=script&lang=js&"
import style0 from "./Quick.vue?vue&type=style&index=0&id=2c98e943&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c98e943",
  null
  
)

export default component.exports